// KPIs › Scorecard's own query keys (KPIS-MODE, founder-approved 2026-10-22), beside the focus
// (`s=seat:{id}` narrows the grid to a seat, `scope=team:{id}` to a team, `p` the week):
//   `branch=1`  with the seat in focus, everyone under it too ("with their branch");
//   `mine=1`    only the seats the viewer holds;
//   `off=1`     only the KPI rows off track this period (missed, or near the target);
//   `kpi={id}`  the metric whose current cell is focused (the chart drawer's KPI rows link here);
//   `cols=month|quarter`  the columns: the last 13 weeks (absent), months or quarters.
const ID = /^[0-9a-f-]{36}$/i;

export type ScorecardColumns = "week" | "month" | "quarter";

export type ScorecardSearch = {
  branch?: true;
  mine?: true;
  off?: true;
  kpi?: string;
  cols?: "month" | "quarter";
};

const on = (v: unknown) => v === true || v === 1 || v === "1" || v === "true";

export function validateScorecardSearch(search: Record<string, unknown>): ScorecardSearch {
  return {
    ...(on(search.branch) ? { branch: true as const } : {}),
    ...(on(search.mine) ? { mine: true as const } : {}),
    ...(on(search.off) ? { off: true as const } : {}),
    ...(typeof search.kpi === "string" && ID.test(search.kpi) ? { kpi: search.kpi } : {}),
    ...(search.cols === "month" || search.cols === "quarter" ? { cols: search.cols } : {}),
  };
}

/** A patch of the scorecard keys onto the current search (`undefined` drops a key). */
export function patchScorecardSearch(
  prev: Record<string, unknown>,
  next: Partial<Record<keyof ScorecardSearch, unknown>>,
): Record<string, unknown> {
  const out: Record<string, unknown> = { ...prev };
  for (const [k, v] of Object.entries(next)) {
    if (v === undefined || v === false || v === null) delete out[k];
    else out[k] = v;
  }
  return out;
}
